/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from 'react'
import styled from "styled-components";

interface IProps {
  vertical?: boolean
  horizontal?: boolean
  flexFlow?: string
  gap?: string
}

const BoxWithCenteredContent = styled.div<IProps>(props => ({
    display: 'flex',
    flexFlow: props.flexFlow ?? 'initial',
    alignItems: props.vertical ? 'center' : 'initial',
    justifyContent: props.horizontal ? 'center' : 'initial',
    gap: props.gap ?? '10px 10px'
  })
)

export default BoxWithCenteredContent